import React from 'react';
import ServicePageLayout from './service/ServicePageLayout';
import residentMobilePageData from '../data/servicePages/residentMobile';

const ResidentMobilePage = () => <ServicePageLayout data={residentMobilePageData} />;

export default ResidentMobilePage;
